import { cn } from "../lib/utils";

interface HexagonProps {
  size: number;
  className?: string;
  filled?: boolean;
  rotate?: number;
  style?: React.CSSProperties;
}

/**
 * Hexagone SVG décoratif. side = `size` (rayon du circumscribed).
 * On l'utilise en absolute pour décorer le hero.
 */
export function Hexagon({ size, className, filled = false, rotate = 0, style }: HexagonProps) {
  const d = size;
  // Hexagone régulier (pointy-top) inscrit dans un carré 2d × 2d.
  const points = Array.from({ length: 6 })
    .map((_, i) => {
      const a = (Math.PI / 3) * i - Math.PI / 2;
      return `${d + d * Math.cos(a)},${d + d * Math.sin(a)}`;
    })
    .join(" ");

  return (
    <svg
      viewBox={`0 0 ${d * 2} ${d * 2}`}
      width={d * 2}
      height={d * 2}
      className={cn("pointer-events-none", className)}
      style={{ transform: `rotate(${rotate}deg)`, ...style }}
      aria-hidden
    >
      <polygon
        points={points}
        fill={filled ? "currentColor" : "none"}
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinejoin="round"
      />
    </svg>
  );
}
